import { ExpandMore, QuestionMark } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { FAKE_TEXT } from "helpers/constants";
import { FC } from "react";

type Step4Props = {
  requirements: any[];
};

export const Step4: FC<Step4Props> = ({ requirements }) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Reflect on and Ask About Student's Performance.
      </Typography>
      <Typography variant="body1" gutterBottom>
        {FAKE_TEXT.LONG2X}
      </Typography>

      <Box mt={2}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <QuestionMark />
            <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
          </Stack>
          <Stack direction="row" spacing={2}>
            <QuestionMark />
            <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
          </Stack>
        </Stack>
      </Box>

      {requirements.length === 0 && (
        <Box mt={2}>
          <Typography variant="body1" color="textSecondary">
            No requirements added yet
          </Typography>
        </Box>
      )}

      <Box mt={2}>
        {requirements.map((requirement) => (
          <Accordion
            key={requirement.reqId}
            sx={{
              my: 2,
              background: "rgba(0,0,0,0.1)",
              position: "relative",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography variant="body1" fontWeight={600}>
                {requirement.requirementName}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">
                {requirement.fullDescription}
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <Link>See Success Rubric</Link>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box>
        <Box mt={2}>
          <Typography variant="h5">
            Discuss modifiable behavioral suggestions for improvement
          </Typography>
        </Box>

        <Box mt={2}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
              <QuestionMark />
              <Typography variant="body1">{FAKE_TEXT.MEDIUM}</Typography>
            </Stack>
          </Stack>
        </Box>

        <Box>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              my: 2,
              background: "rgba(25,118,210,0.2)",
              border: "none",
              position: "relative",
            }}
          >
            {FAKE_TEXT.LONG}
          </Paper>
        </Box>
      </Box>
    </>
  );
};
